import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import InputBox from '../InputBox/InputBox';
import { isEmailValid } from '@solarwindscloud/swicus-validation';

export const testIds = {
  emailInput: 'email-input',
};

const EmailInput = ({ onError, value, hasError, allowEmpty, errorMessage, placeholder, ...props }) => {
  const ERROR_MESSAGE = 'Enter a valid email address';

  const validate = useCallback(() => {
    if ((!allowEmpty || value.length > 0) && !isEmailValid(value)) {
      if (onError) onError(errorMessage || ERROR_MESSAGE);
    }
  }, [onError, allowEmpty, value, errorMessage]);

  return (
    <InputBox
      {...props}
      label="Email"
      name="email"
      icon="email"
      placeholder={placeholder || 'Your email address'}
      onBlur={validate}
      errorMessage={hasError ? errorMessage || ERROR_MESSAGE : null}
      type="email"
      value={value}
      dataTestString={testIds.emailInput}
    />
  );
};

EmailInput.displayName = 'EmailInput';
EmailInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  hasError: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  autoFocus: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default EmailInput;
